import countryList from "country-list";

export const countryFormatter = (code: string) => {
  const country = countryList.getData().find((c) => c.code === code);

  if (!country) return;

  return {
    img: getFlagUrl(country.code),
    name: country.code === "GB" ? "United Kingdom" : country.name,
  };
};

export const getFlagUrl = (code: string, size?: 20 | 40) =>
  `https://flagcdn.com/w${size || 20}/${code.toLowerCase()}.png`;
